/**
 * 개발 로그(D-19). 학생 화면에는 내부 코드를 보이지 않고 여기에만 남긴다.
 * 기록 대상: 제출의 request_in_unknown_state·request_key_reused, 저장의 request_key_reused, 알 수 없는 응답.
 * 서버 수집 경로는 아직 없다(미구현). 지금은 브라우저 콘솔과 window.__growingDevLog에만 남는다.
 */
export interface DevLogEntry {
  readonly at: string;
  readonly code: string;
  readonly op: 'submit' | 'save' | 'items' | 'auth' | 'result' | 'evidence' | 'words' | 'quiz' | 'other';
  readonly key: string | null;
  /** 같은 키로 이 코드를 받은 횟수 */
  readonly sameKeyCount: number;
  /** 같은 키로 3번 이상 반복되면 표시 */
  readonly repeated: boolean;
  readonly detail?: string;
}

const entries: DevLogEntry[] = [];
const perKey = new Map<string, number>();

export function devlog(op: DevLogEntry['op'], code: string, key: string | null, detail?: string): void {
  const k = `${op}:${code}:${key ?? '-'}`;
  const n = (perKey.get(k) ?? 0) + 1;
  perKey.set(k, n);
  const e: DevLogEntry = { at: new Date().toISOString(), code, op, key, sameKeyCount: n, repeated: n >= 3, ...(detail === undefined ? {} : { detail }) };
  entries.push(e);
  if (entries.length > 300) entries.shift();
  // eslint-disable-next-line no-console
  console.warn('[growing devlog]', JSON.stringify(e));
}

export const devlogEntries = (): readonly DevLogEntry[] => entries;

export function exposeDevlog(): void {
  (globalThis as any).__growingDevLog = entries;
}
